import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Observable } from "rxjs";
import { HttpclientService } from "../../../../shared";
import { UpdateExitTimeRequest } from "./UpdateExitTimeRequest";

@Injectable()
export class TimeSetupService {
	constructor(private httpclientService: HttpclientService) {}

	TimeSettingsSchoolSelectList(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/TimeSettingsSchoolSelectList?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	TimeSettingsUpdateTardyTime(SchoolID, TardyTime) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/TimeSettingsUpdateTardyTime?SchoolID=" + SchoolID + "&TardyTime=" + TardyTime;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	TimeSettingsUpdateTardyType(SchoolID, CorrelateSelectID) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/TimeSettingsUpdateTardyType?SchoolID=" + SchoolID + "&CorrelateSelectID=" + CorrelateSelectID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	TimeSettingsLoadPrefs(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/TimeSettingsLoadPrefs?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	TimeSettingsUpdateExitTime(parms: UpdateExitTimeRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/TimeSettingsUpdateExitTime?";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	TestTardyTimes(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/TestTardyTimes?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	TimeSettingsAcademySelectList(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/TimeSettingsAcademySelectList?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	TimeSettingsUpdateAcademyTardyTime(AcademyID, TardyTime) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/TimeSettingsUpdateAcademyTardyTime?AcademyID=" + AcademyID + "&TardyTime=" + TardyTime;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	TimeSettingsGradeSelectList(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/TimeSettingsGradeSelectList?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	TimeSettingsUpdateGradeTardyTime(GradeLevelID, SchoolID, TardyTime) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/TimeSettingsUpdateGradeTardyTime?GradeLevelID=" + GradeLevelID + "&SchoolID=" + SchoolID + "&TardyTime=" + TardyTime;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	TimeSettingsHomeroomSelectList(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/TimeSettingsHomeroomSelectList?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	TimeSettingsUpdateHomeroomTardyTime(HomeroomID, TardyTime) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/TimeSettingsUpdateHomeroomTardyTime?HomeroomID=" + HomeroomID + "&TardyTime=" + TardyTime;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	TimeSettingsPeriodSelectList(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/PeriodList?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	TimeSettingsUpdatePeriodTardyTime(PeriodID, TardyTime) {
		var postResult$ = new Subject();
		var url = "SchoolSettings/TimeSettingsUpdatePeriodTardyTime?PeriodID=" + PeriodID + "&TardyTime=" + TardyTime;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
